module.exports = __webpack_public_path__ + "static/media/work.9b63725b.jpg";